'use client';

import cx from 'classix';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { DEFAULT_LISTING_PART_VARIANTS } from '@/features/listing/constants/listing-constants';
import { type ListingType } from '@/features/listing/types/listing-types';
import {
  Link,
  usePathname,
} from '@/i18n/routing';
import getTypedObjectKeys from '@/shared/utils/get-typed-object-keys';
import ListingTypeSvg from '@/ui/svg/listing-type-svg';

import styles from './listing-types-boxes.module.scss';

interface ListingTypesBoxesProps {
  listingType: ListingType,
}

export default function ListingTypesBoxes(props: ListingTypesBoxesProps) {
  const { listingType } = props;
  const translationsListingType = useTranslations('home.listing.service-type-landing');

  const pathname = usePathname();
  const queryParams = useSearchParams();

  const listingTypes = getTypedObjectKeys(DEFAULT_LISTING_PART_VARIANTS);

  return (
    <div className={styles.listingTypes}>
      {listingTypes.map((listingTypeOption) => {
        const linkQueryParams = new URLSearchParams(queryParams);

        if (listingTypeOption === 'haveshare') {
          linkQueryParams.delete('listing_type');
        } else {
          linkQueryParams.set('listing_type', listingTypeOption);
        }

        return (
          <Link
            key={listingTypeOption}
            href={`${pathname}?${linkQueryParams.toString()}`}
            className={cx(
              styles.listingTypes_item,
              listingTypeOption === listingType && styles.listingTypes_item__selected,
            )}
          >
            <div className={styles.listingTypes_image}>
              <ListingTypeSvg type={listingTypeOption} />
            </div>

            <p className={styles.listingTypes_text}>
              {translationsListingType(listingTypeOption)}
            </p>
          </Link>
        );
      })}
    </div>
  );
}
